import Account from './../Sellpoint/Template/script.js'



export default {
    name: 'Settings',
    mixins: [Account],
    data () {
        return {
            
        }
    },

    components: {
        
    },
     
    methods: {

        backTo(){
            window.history.back(); 
        },
      
    },

    created: function(){
        this.loading = true;
        let self = this;
        setTimeout(function(){ self.setSellpoint(); }, 3000); //wait for 3sec 
    }
}


// WEBPACK FOOTER //
// ./src/pages/Account/Settings/script.js